import { render, staticRenderFns } from "./history.vue?vue&type=template&id=34a438f0&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"
import style0 from "./history.vue?vue&type=style&index=0&id=34a438f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a438f0",
  null
  
)

export default component.exports